import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import { tryToFetchSinglePurchase } from '../../../../store/brokers/partner/purchases/PurchasesSlice';
import Modal from '../../../../shared/modal';
import Table from '../../../../shared/table';
import Button from '../../../../shared/button';


interface IPurchaseDetailsModal {
    openModal: boolean;
    purchaseId: string;
    handleCloseModal: () => void;
}

const PurchaseDetailsModal = ({
    openModal,
    purchaseId,
    handleCloseModal,
}: IPurchaseDetailsModal) => {
    const dispatch = useAppDispatch();
    const [purchaseDetails, setPurchaseDetails] = useState<any>();
    const state = useAppSelector((state) => state?.purchases);

    useEffect(() => {
        setPurchaseDetails(state?.purchaseDetails)
    }, [state?.purchaseDetails])

    useEffect(() => {
        if (purchaseId) {
            dispatch(tryToFetchSinglePurchase(purchaseId || ''))
        } else {
            setPurchaseDetails(undefined)
        }
    }, [purchaseId, openModal])

    const onCloseModal = () => {
        handleCloseModal();
        setPurchaseDetails(undefined)
    }

    let findTotalQuantity = 0;

    purchaseDetails?.items && purchaseDetails?.items?.length > 0 &&
        [...purchaseDetails?.items].map((currentValue: any) => {
            findTotalQuantity = Number(findTotalQuantity) + Number(currentValue?.qty || 0);
            return currentValue;
        });

    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Purchase Details'
            contentContainerStyle='!min-w-[70vw]'>
            <div className={'p-2 min-w-[65vw] min-h-[300px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Details</p>
                </div>
                <div className='bg-[#f8f9fc] rounded-[6px] p-3'>
                    <p className='text-[20px]'>Review Details</p>
                    <div className='grid grid-cols-4 span-2 my-3 border-b border-[#e4e4e4] pb-2'>
                        {purchaseDetails?.supplierInfo &&
                            <div className='mb-2'>
                                <span>Supplier: </span>
                                <span className='font-bold'>{purchaseDetails?.supplierInfo?.name}</span>
                            </div>
                        }
                        {purchaseDetails?.partner &&
                            <div className='mb-2'>
                                <span>Order Created: </span>
                                <span className='font-bold'>{purchaseDetails?.partner?.companyName}</span>
                            </div>
                        }
                        {purchaseDetails?.status &&
                            <div className='mb-2'>
                                <span>Status: </span>
                                <span className='font-bold'>{purchaseDetails?.status}</span>
                            </div>
                        }
                        {purchaseDetails?.expectedDeliveryDate &&
                            <div className='mb-2'>
                                <span>Delivery Date: </span>
                                <span className='font-bold'>{moment(purchaseDetails?.expectedDeliveryDate).format('DD MMMM YYYY')}</span>
                            </div>
                        }
                    </div>
                    <div className=' border-b border-[#e4e4e4] pb-2 my-2'>
                        <Table
                            columns={['Item', 'Price per Unit', 'Units', 'Subtotal']}
                            hidePagination={true}
                            headStyle='!bg-[#000000] !text-white'>
                            {purchaseDetails?.items && purchaseDetails?.items?.length > 0 && purchaseDetails?.items?.map((row: any, idx: number) => {
                                const findCurrency = purchaseDetails?.currency
                                return (
                                    <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                        <td className='px-6 py-4'>{row?.itemName}</td>
                                        <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(findCurrency || '')}`]}{Number(row?.price || 0).toFixed(2)}</td>
                                        <td className='px-6 py-4'>{row?.qty || ''} unit(s)</td>
                                        <td className='px-6 py-4'>
                                            {CURRENCY_SYMBOLS[`${(findCurrency || '')}`]}{(Number(row?.price || 0) * Number(row?.qty || 0)).toFixed(2)}
                                        </td>
                                    </tr>
                                )
                            })}
                            {purchaseDetails?.items && purchaseDetails?.items?.length > 0 &&
                                <tr className='!font-bold !text-black !border-t-2 border-[#f7a21e]'>
                                    <td></td>
                                    <td className='px-6 py-4'>Total:</td>
                                    <td className='px-6 py-4'>{findTotalQuantity} unit(s)</td>
                                    <td className='px-6 py-4'>
                                        {CURRENCY_SYMBOLS[`${(purchaseDetails?.currency || '')}`]}{Number(purchaseDetails?.purchaseInfo?.subtotal || 0).toFixed(2)}
                                    </td>
                                </tr>
                            }
                        </Table>
                        <div className='mt-2 grid grid-cols-2 span-2 min-w-[100%]'>
                            <div >
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Total Items</p>
                                    <p className='text-[20px] text-primary-default'>{findTotalQuantity} Units</p>
                                </div>
                                {purchaseDetails?.purchaseInfo &&
                                    <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                        <p className='text-[20px]'>Shipping Costs</p>
                                        <p className='text-[20px] text-primary-default'>
                                            {CURRENCY_SYMBOLS[`${(purchaseDetails?.currency || '')}`]}{Number(purchaseDetails?.purchaseInfo?.shippingCosts || 0).toFixed(2)}
                                        </p>
                                    </div>
                                }
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Total Amount</p>
                                    <p className='text-[20px] text-primary-default'>
                                        {CURRENCY_SYMBOLS[`${(purchaseDetails?.currency || '')}`]}{Number(purchaseDetails?.purchaseInfo?.grandTotal || 0).toFixed(2)}
                                    </p>
                                </div>
                            </div>
                            <div className='flex flex-row justify-center items-center self-center'>
                                <Button
                                    label={'Close'}
                                    className='btn-primary min-w-[150px] mr-3 !rounded'
                                    onClickButton={() => onCloseModal()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}
export default PurchaseDetailsModal;